// extracted by mini-css-extract-plugin
module.exports = {"explainerModal":"ExplainerModalContent_explainerModal__cVQf2","badge":"ExplainerModalContent_badge__RlBdu","subtitle":"ExplainerModalContent_subtitle__n3B7P"};